module.exports = __webpack_public_path__ + "img/gift-ui-02.29e98d6b.png";